export default "__VITE_ASSET__7b29d6a2__"